import { LitElement, html } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { nothing } from 'lit-html';
import { DebugService } from '../../shared/services/debug.service.js';
import { style } from './iconic-confirm.style.js';
import { VehicleService } from '../../services/vehicle.service.js';
import '../../shared/modals/papr-limit/papr-limit-modal.component.js';
import '../iconic-loan/iconic-loan-card/iconic-loan-card.component.js';
import '../iconic-vehicle-loan/iconic-vehicle-loan-card/iconic-vehicle-loan-card.component.js';
import '../iconic-vehicle/iconic-vehicle-card/iconic-vehicle-card.component.js';
import '../iconic-container/iconic-container.component.js';
import { ApplicationService } from '../../services/application.service.js';
import { stratum } from '../../../constants/stratum.js';
import { VehicleAndLoanService } from '../../services/vehicle-and-loan.service.js';

export class RefiIconicConfirm extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicConfirm');
    this.isVehicleEligible = true;
    this.marketingOffer = ApplicationService.MarketingOffer;
  }

  static properties = {
    callingCustomerLoans: { type: Boolean },
    isCaponeLoan: { type: Boolean },
    useManualEntry: { type: Boolean },
    selectedMatchedVehicle: { type: Boolean },
    usedLicensePlateSearch: { type: Boolean },
    manualLoanModel: { type: Object },
    paprModal: { type: Object },
    errorMessage: { type: String },
    selectedOffer: { type: Object },
  };

  firstUpdated() {
    if (!ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION
      );
    }
  }

  static styles = [style, fsTypography];

  render() {
    this.debug.log('rendered');
    return html`
      <refi-track-pageview pagename="confirm"></refi-track-pageview>
      <refi-iconic-container
        headerText="Confirm the car and loan you want to refinance"
        .marketingOffer="${this.marketingOffer}"
        ctaButtonText="${ApplicationService.isInvisiblePQ
          ? 'Check eligibility'
          : 'Looks good'}"
        @cta-clicked="${this.submitVehicleAndLoan}"
      >
        <refi-iconic-vehicle-loan-card
          .vehicle="${this.vehicle}"
          .loan="${this.loan}"
          vehicleAndLoanIndex="0"
          .showButton="${false}"
          .canEdit="${true}"
          hide-ineligibility="${ApplicationService.isInAppDeclineDelayOn
            ? ''
            : nothing}"
        ></refi-iconic-vehicle-loan-card>
      </refi-iconic-container>
    `;
  }

  connectedCallback() {
    super.connectedCallback();

    this.vehicle = VehicleService.selectedVehicle;
    this.loan = ApplicationService.selectedLoan;
    this.debug.log(this.loan);
    this.sendHostAppHeaderUpdates();

    if (ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION_2
      );
    }
  }

  submitVehicleAndLoan() {
    if (ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(
        TagKey.ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA_2
      );
      stratum.publishTag(TagKey.ICONIC_VEHICLE_AND_LOAN_CALCULATED_LTV, {
        replacements: {
          value: `${
            (Number(this.loan.currentBalance) /
              Number(this.vehicle?.wholeSaleValue)) *
            100
          }%`,
        },
      });
      if (
        VehicleAndLoanService.getInAppDeclineReason(this.vehicle, this.loan)
      ) {
        this.dispatchEvent(
          new CustomEvent('delayed-decline', {
            bubbles: true,
            composed: true,
          })
        );
        return;
      }
    } else {
      stratum.publishTag(TagKey.ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA);
    }
    this.debug.log('route to review');

    this.dispatchEvent(
      new CustomEvent('submit-vehicle-loan', {
        bubbles: true,
        composed: true,
      })
    );
  }

  sendHostAppHeaderUpdates() {
    this.dispatchEvent(
      new CustomEvent('show-progress-bar', {
        detail: {
          displayBar: true,
        },
        composed: true,
        bubbles: true,
      })
    );
    this.dispatchEvent(
      new CustomEvent('header-bottom-slot-color-change', {
        bubbles: true,
        composed: true,
        detail: { colored: false },
      })
    );
  }
}

customElements.define('refi-iconic-confirm', RefiIconicConfirm);
